import Route from '../Route'
import { CustomSwitch } from '../../components/CustomSwitch'
import DownloadXmlBatch from 'pages/Financial/DownloadXmlBatch/List'

export const DownloadXmlBatchRouter = (): JSX.Element => (
  <CustomSwitch>
    <Route
      path="/financial/downloadXmlBatch"
      exact
      component={DownloadXmlBatch}
    />
  </CustomSwitch>
)
